module.exports = __webpack_public_path__ + "img/symptoms.e945adb3.svg";